import {
  AccountProvider as BaseAccountProvider,
  ConnectionResponse,
  Signer,
} from "rujira.js";
import { default as brave } from "./brave";
import { default as coinbase } from "./coinbase";
import { default as ctrl } from "./ctrl";
import { default as keplr } from "./keplr";
import { default as leap } from "./leap";
// import { default as ledger } from "./ledger";
import { default as daodao } from "./daodao";
import { default as metamask } from "./metamask";
import { default as okx } from "./okx";
import { default as rabby } from "./rabby";
import { default as station } from "./station";
import { default as ton } from "./ton";
import { default as tronlink } from "./tronlink";
import { default as trust } from "./trust";
import { default as vultisig } from "./vulticonnect";
import { default as xaman } from "./xaman";

export type AccountProvider = BaseAccountProvider<Provider.Key>;

export const NO_ACCOUNT_PROVIDER: AccountProvider = {
  accounts: undefined,
  signer: function (): Signer {
    throw new Error("Function not implemented.");
  },
  select: function (): void {
    throw new Error("Function not implemented.");
  },
  connect: function (): ConnectionResponse {
    throw new Error("Function not implemented.");
  },
  disconnect: function (): void {
    throw new Error("Function not implemented.");
  },
  disconnectAll: function (): void {
    throw new Error("Function not implemented.");
  },
  isAvaialable: function (): boolean {
    throw new Error("Function not implemented.");
  },
};

export namespace Provider {
  export type Key =
    | "Brave"
    | "Coinbase"
    | "Ctrl"
    | "DaoDao"
    | "Keplr"
    | "Leap"
    | "Ledger"
    | "Metamask"
    | "Okx"
    | "Rabby"
    | "Station"
    | "Ton"
    | "Tronlink"
    | "Trust"
    | "Vultisig"
    | "Xaman";

  export const signer = (p: Key): Signer => {
    switch (p) {
      case "Brave":
        return brave;
      case "Coinbase":
        return coinbase;
      case "Ctrl":
        return ctrl;
      case "DaoDao":
        return daodao;
      case "Keplr":
        return keplr;
      case "Leap":
        return leap;
      case "Ledger":
        throw new Error(`No signer for Ledger`);
      case "Metamask":
        return metamask;
      case "Okx":
        return okx;
      case "Rabby":
        return rabby;
      case "Station":
        return station;
      case "Ton":
        return ton;
      case "Tronlink":
        return tronlink;
      case "Trust":
        return trust;
      case "Vultisig":
        return vultisig;
      case "Xaman":
        return xaman;
    }
  };
}
